import {useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../store";
import { visualizerActions } from '../../store';
import undo from './assets/undo.svg';
import redo from './assets/redo.svg';

import styles from './VisualizerControls.module.css';
import { resetPattern } from "../../Helpers/SvgHelper";

export default function VisualizerControls() {
    const dispatch = useDispatch();
    const tileSelections = useSelector(state => state.visualizer.tileSelections);
    const colorHistoryIndex = useSelector(state => state.visualizer.colorHistoryIndex);
    const colorSelectionHistory = useSelector(state => state.visualizer.colorSelectionHistory);

    // Check if undo/redo should be enabled
    const canUndo = colorHistoryIndex > 0;
    const canRedo = colorHistoryIndex < colorSelectionHistory.length - 1;

    const handleShowSceneSelector = function(){
        dispatch(uiActions.setViewInRoomModalActive(true));
    };

    const clearPattern = function() {
        resetPattern();
        dispatch(visualizerActions.clearTileSelections(true));
        dispatch(visualizerActions.clearAllSlots());
    }

    const handleUndoRedo = function(direction) {
        if (direction === -1) {
            // Undo
            dispatch(visualizerActions.undoColorSelection());
        } else if (direction === 1) {
            // Redo
            dispatch(visualizerActions.redoColorSelection());
        }
    }

    return(
        <>
          <div className={styles.contentDiv}>
            <li className={styles.lowerControls}>
                <button className={styles.viewBtn} onClick={handleShowSceneSelector}>
                    View in a Room
                </button>

            </li>
            <li className={styles.upperControls}>
                <button className={styles.clearBtn} onClick={clearPattern}>Clear Pattern</button>
                <button 
                    className={`${styles.borderBtn} ${!canUndo ? styles.disabled : ''}`} 
                    onClick={() => handleUndoRedo(-1)}
                    disabled={!canUndo}
                >
                    <img src={undo} alt="undo" width="25" />
                </button>
                <button 
                    className={`${styles.borderBtn} ${!canRedo ? styles.disabled : ''}`} 
                    onClick={() => handleUndoRedo(1)}
                    disabled={!canRedo}
                >
                    <img src={redo} alt="redo" />
                </button>

            </li>
            </div>
        </>
    );
}